<div class="col-sm-4">
    <input
        [(ngModel)]="tsCompany.salesPerson"
        [placeholder]="'session-details.student-tab.salesPersonPlaceholder' | translate"
        class="form-control input-sm"
        name="sales-person"
        autocomplete="off"
        auto-complete
        [source]="searchSalesPersons.bind(this)"
        [min-chars]="1"
        [value-formatter]="formatSalesPerson"
        [list-formatter]="formatSalesPerson"
    >
</div>
<div class="col-sm-8" *ngIf="tsCompany.name">
    {{ 'session-details.student-tab.salesPersonWillBeSavedToCompany' | translate }}
    {{tsCompany.name}}
</div>



// WEBPACK FOOTER //
// ./src/app/_screens/session/detail/registration/registration-company/sales-person-edition/sales-person-edition.component.html